var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", { staticClass: "cursive" }, [_vm._v("Dettaglio totale")]),
    _vm._v(" "),
    _vm.flightFromPartenza && _vm.flightToDestinazione
      ? _c("div", { staticClass: "mb-3" }, [
          _c("h5", { staticClass: "mb-0" }, [_vm._v("Volo")]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex" }, [
            _c("div", [
              _c("b", { staticClass: "text-uppercase" }, [
                _vm._v(
                  _vm._s(
                    _vm.airportName(
                      _vm.flightFromPartenza.partenza.aeroporto.city.objA
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("|")]),
              _vm._v(" "),
              _c("span", { staticClass: "text-uppercase" }, [
                _vm._v(
                  _vm._s(
                    _vm.airportName(
                      _vm.flightFromPartenza.partenza.aeroporto.airport.objB
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "mdi mdi-arrow-right mdi-16px" }),
              _vm._v(" "),
              _c("b", { staticClass: "text-uppercase" }, [
                _vm._v(
                  _vm._s(
                    _vm.airportName(
                      _vm.flightFromDestinazione.destinazione.aeroporto.city
                        .objA
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("|")]),
              _vm._v(" "),
              _c("span", { staticClass: "text-uppercase" }, [
                _vm._v(
                  _vm._s(
                    _vm.airportName(
                      _vm.flightFromDestinazione.destinazione.aeroporto.airport
                        .objB
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "(" +
                    _vm._s(
                      _vm.smallDateFormatter(
                        _vm.toDateFromServer(
                          _vm.flightFromDestinazione.partenza.dataOra.date.date
                        )
                      )
                    ) +
                    ")"
                )
              ])
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", [
              _c("b", { staticClass: "text-uppercase" }, [
                _vm._v(
                  _vm._s(
                    _vm.airportName(
                      _vm.flightToPartenza.partenza.aeroporto.city.objA
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("|")]),
              _vm._v(" "),
              _c("span", { staticClass: "text-uppercase" }, [
                _vm._v(
                  _vm._s(
                    _vm.airportName(
                      _vm.flightToPartenza.partenza.aeroporto.airport.objB
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "mdi mdi-arrow-right mdi-16px" }),
              _vm._v(" "),
              _c("b", { staticClass: "text-uppercase" }, [
                _vm._v(
                  _vm._s(
                    _vm.airportName(
                      _vm.flightToDestinazione.destinazione.aeroporto.city.objA
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("|")]),
              _vm._v(" "),
              _c("span", { staticClass: "text-uppercase" }, [
                _vm._v(
                  _vm._s(
                    _vm.airportName(
                      _vm.flightToDestinazione.destinazione.aeroporto.airport
                        .objB
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "(" +
                    _vm._s(
                      _vm.smallDateFormatter(
                        _vm.toDateFromServer(
                          _vm.flightToDestinazione.destinazione.dataOra.date
                            .date
                        )
                      )
                    ) +
                    ")"
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.hasArrivalServiceTransfer()
            ? _c("p", [
                _c("b", [_vm._v("1 notte in transito")]),
                _vm._v(" - andata")
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.hotels && _vm.camere
      ? _c("div", { staticClass: "mb-3" }, [
          _c("h5", { staticClass: "mb-0" }, [_vm._v("Hotel")]),
          _vm._v(" "),
          _c(
            "div",
            _vm._l(_vm.hotels, function(item, index) {
              return _c("div", { key: index }, [
                _c("div", [
                  _c("b", [
                    _vm._v(_vm._s(_vm.hotelName(item.hotel.location.name)))
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "(" +
                        _vm._s(_vm.middleDateFormatter(item.period.start)) +
                        " - " +
                        _vm._s(_vm.middleDateFormatter(item.period.end)) +
                        ")"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  _vm._l(item.groups, function(group, index) {
                    return _c("p", { key: index, staticClass: "mb-0" }, [
                      _vm._v(
                        "Camera " +
                          _vm._s(group.travelGroupId) +
                          " (" +
                          _vm._s(
                            _vm.cameraText(_vm.camere[group.travelGroupId - 1])
                          ) +
                          "):\n                        "
                      ),
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            group.rooms.find(function(room) {
                              return room.selected
                            }).roomInfo.description
                          )
                        )
                      ])
                    ])
                  }),
                  0
                )
              ])
            }),
            0
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.tour && _vm.tour.anagrafica
      ? _c("div", { staticClass: "mb-3" }, [
          _c("h5", { staticClass: "mb-0" }, [_vm._v("Tour")]),
          _vm._v(" "),
          _c("div", [
            _c("b", [
              _vm._v(_vm._s(_vm.hotelName(_vm.tour.anagrafica.element.name)))
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "(" + _vm._s(_vm.tour.anagrafica.element.days) + " giorni)"
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.services
      ? _c("div", { staticClass: "mb-3" }, [
          _c("h5", { staticClass: "mb-0" }, [_vm._v("Attività")]),
          _vm._v(" "),
          _c(
            "div",
            _vm._l(_vm.services, function(item, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c("b", [_vm._v(_vm._s(item.detail.name))]),
                  _vm._v("\n                ("),
                  _vm._l(item.groups, function(group, index) {
                    return _c("span", { key: index, staticClass: "px-1" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.smallDateFormatter(group.dateSelected)) +
                          "\n                "
                      )
                    ])
                  }),
                  _vm._v(")\n            ")
                ],
                2
              )
            }),
            0
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.trasferimenti
      ? _c("div", { staticClass: "mb-2" }, [
          _c("h5", { staticClass: "mb-0" }, [_vm._v("Trasferimenti")]),
          _vm._v(" "),
          _c(
            "div",
            _vm._l(_vm.trasferimenti, function(item, index) {
              return _c("div", { key: index }, [
                _c("b", [_vm._v(_vm._s(item.detail.name))]),
                _vm._v(" "),
                item.andata ? _c("span", [_vm._v(" - andata")]) : _vm._e(),
                _vm._v(" "),
                item.ritorno ? _c("span", [_vm._v(" - ritorno")]) : _vm._e()
              ])
            }),
            0
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center px-2" }, [
      _c("span", [_vm._v("-")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c74d2954", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c74d2954","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/SummaryPreventivo.vue
// module id = null
// module chunks = 